var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.user
    ? _c(
        "div",
        {
          staticStyle: {
            color: "whitesmoke",
            "background-color": "gray",
            padding: "30px 20px",
          },
        },
        [
          _c(
            "v-layout",
            {
              attrs: {
                "align-center": "",
                "justify-space-around": "",
                wrap: "",
              },
            },
            [
              _c(
                "v-avatar",
                { attrs: { color: "grey lighten-2", size: "90" } },
                [
                  _c(
                    "v-icon",
                    { attrs: { size: "50", color: "grey darken-1" } },
                    [_vm._v("mdi-account-circle")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "headline",
              staticStyle: { "text-align": "center", padding: "20px 0px" },
            },
            [_vm._v(" " + _vm._s(_vm.user.nome) + " ")]
          ),
          _c("v-divider"),
          _c("div", { staticStyle: { "padding-top": "20px" } }, [
            _c("p", [_vm._v(" ID: "), _c("em", [_vm._v(_vm._s(_vm.user.id))])]),
            _c("p", [
              _vm._v(" RUOLI: "),
              _c("em", [_vm._v(_vm._s(_vm.user.roles.join(", ")))]),
            ]),
          ]),
          _vm.userIsAdmin
            ? _c(
                "div",
                {
                  staticStyle: {
                    "margin-top": "20px",
                    "background-color": "lightcoral",
                    padding: "10px",
                    "text-align": "center",
                    color: "white",
                  },
                },
                [_c("strong", [_vm._v("ADMIN")])]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }